import { render } from "./StudentListCourse.vue?vue&type=template&id=10d692ca&scoped=true"
import script from "./StudentListCourse.vue?vue&type=script&lang=js"
export * from "./StudentListCourse.vue?vue&type=script&lang=js"

import "./StudentListCourse.vue?vue&type=style&index=0&id=10d692ca&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d692ca"]])

export default __exports__